import { render, staticRenderFns } from "./ShipmentView.vue?vue&type=template&id=63941981"
import script from "./ShipmentView.vue?vue&type=script&lang=js"
export * from "./ShipmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports